import { jsxs, jsx } from "react/jsx-runtime";
import { toolOutputToFeaturedProduct, sectionFadeInStyle } from "./utils.js";
import { FeaturedProductWidget } from "../FeaturedProductWidget.js";
function DataFeaturedProductPart({
  part
}) {
  const data = part.data;
  if (!data || !data.stacklineSku) return null;
  const product = toolOutputToFeaturedProduct(data);
  return /* @__PURE__ */ jsxs("div", { style: { animation: "concierge-fade-in 0.35s ease-out both" }, children: [
    /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: sectionFadeInStyle } }),
    /* @__PURE__ */ jsx(FeaturedProductWidget, { product })
  ] });
}
export {
  DataFeaturedProductPart
};
//# sourceMappingURL=DataFeaturedProductPart.js.map
